import axios from 'axios';
import * as Sentry from '@sentry/react';

export const v3_prod = 'https://api.cplat.io/v3';
export const v3_dev = 'https://devapi.cplat.io/v3';

// prod
const prod = 'https://api.cplat.io/v2';
// dev
const dev = 'https://devapi.cplat.io/v2';
// const dev = 'https://api.cplat.io/v2';

// TODO 에러
export const baseURL = import.meta.env.MODE === 'development' ? dev : prod;
export const v3BaseURL = import.meta.env.MODE === 'development' ? v3_dev : v3_prod;

export const cplatApiV2 = axios.create({
  baseURL,
  headers: { 'Content-Type': 'application/json' },
});

// 버블링을 통한 최상단에서 network error 보고
cplatApiV2.interceptors.response.use(
  (res) => res,
  (err) => {
    Sentry.captureException(err, {
      tags: { key: 'network' },
    });
  },
);

export const cplatApiV3 = axios.create({
  baseURL: v3BaseURL,
  headers: { 'Content-Type': 'application/json' },
});

// 버블링을 통한 최상단에서 network error 보고
cplatApiV3.interceptors.response.use(
  (res) => res,
  (err) => {
    Sentry.captureException(err, {
      tags: { key: 'network' },
    });
    return Promise.reject(err);
  },
);

/** sellkey api 호출 */
const prodSellkey = 'https://staging-api.cplat.io/v2';
const devSellkey = 'https://devapi.cplat.io/v2';

export const baseURLSellkey = import.meta.env.MODE === 'development' ? devSellkey : prodSellkey;

export const cplatApiV2Sellkey = axios.create({
  baseURL: baseURLSellkey,
  headers: { 'Content-Type': 'application/json' },
});

cplatApiV2Sellkey.interceptors.response.use(
  (res) => res,
  (err) => {
    Sentry.captureException(err, {
      tags: { key: 'network' },
    });
  },
);

// GPT API axios 설정
const prodGpt = 'https://gpt-api.cplat.io/';

export const cplatGPTApi = axios.create({
  baseURL: prodGpt,
  headers: { 'Content-Type': 'application/json' },
});

cplatGPTApi.interceptors.response.use(
  (res) => res,
  (err) => {
    Sentry.captureException(err, {
      tags: { key: 'network' },
    });
  },
);

// 뉴스 브리핑 API axios 설정
const workerDev = 'https://sellerbox-worker-dev-gateway.cplat.io';
const workerProd = 'https://sellerbox-worker-gateway.cplat.io';

export const baseURLNews = import.meta.env.MODE === 'development' ? workerDev : workerProd;

export const cplatWorkerApi = axios.create({
  baseURL: baseURLNews,
  headers: { 'Content-Type': 'application/json' },
});

cplatWorkerApi.interceptors.response.use(
  (res) => res,
  (err) => {
    Sentry.captureException(err, {
      tags: { key: 'network-news' },
    });
  },
);
